<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-office-building-marker-outline',
          title: 'Bureau',
          text: 'Titian Grandjean<br/>Rue St-Hubert 18<br/>CH-2340 Le noirmont',
        },
        {
          icon: 'mdi-map-marker-outline',
          title: 'Atelier',
          text: 'Rue de la communance 165<br/>CH-2362 Montfaucon',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Téléphone',
          text: '+41 78 940 45 48',
        },
        {
          icon: 'mdi-email',
          title: 'E-mail',
          text: 'info@ironwood.ch',
        },
      ],
    }),
  }
</script>
